export default "__VITE_ASSET__12Rgtcjg__"